import { useMemo, useState, useCallback } from "react";

export const PERIODS = [
  { id: "today", label: "Today" }, { id: "7d", label: "7 days" },
  { id: "30d", label: "30 days" }, { id: "mtd", label: "Month to date" },
  { id: "all", label: "All time" },
];

export function boundsFor(period, now = new Date()) {
  const to = new Date(now); to.setHours(23, 59, 59, 999);
  const from = new Date(now); from.setHours(0, 0, 0, 0);
  if (period === "today") return { from: from.toISOString(), to: to.toISOString() };
  if (period === "7d") { from.setDate(from.getDate() - 6); return { from: from.toISOString(), to: to.toISOString() }; }
  if (period === "30d") { from.setDate(from.getDate() - 29); return { from: from.toISOString(), to: to.toISOString() }; }
  if (period === "mtd") { from.setDate(1); return { from: from.toISOString(), to: to.toISOString() }; }
  return { from: undefined, to: undefined };
}

export default function usePeriodFilter(initial = "30d") {
  const [period, setPeriodState] = useState(initial);
  const bounds = useMemo(() => boundsFor(period), [period]);
  const setPeriod = useCallback((id) => setPeriodState(PERIODS.some(({ id: option }) => option === id) ? id : "30d"), []);
  const currentLabel = period === "mtd" ? "Month to date — first day of this month through today" : PERIODS.find((p) => p.id === period)?.label || "";
  return { period, setPeriod, from: bounds.from, to: bounds.to, options: PERIODS, currentLabel };
}
